/**
 * Pre-compiled localized messages for DatePicker component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import datePickerMessages_en from "./intl/en";
import datePickerMessages_de from "./intl/de";
import datePickerMessages_es from "./intl/es";
import datePickerMessages_fr from "./intl/fr-FR";
import datePickerMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const datePickerMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(datePickerMessages_en),
  de: normalizeMessages(datePickerMessages_de),
  es: normalizeMessages(datePickerMessages_es),
  "fr-FR": normalizeMessages(datePickerMessages_fr),
  "pt-BR": normalizeMessages(datePickerMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for DatePicker component
 */
export type DatePickerMessageKey =
  | "Time.enterTime"
  | "Time.enterTimeHour"
  | "Time.enterTimeHourMinute"
  | "Time.enterTimeHourMinuteSecond"
  | "Time.startTime"
  | "clearInput";
